<div class="document-builder">
  <div class="position-sticky top-0">
    <ng-content select="[laDocumentBuilderPanelTop]"></ng-content>
  </div>
  <div class="document-builder-container">
    <div class="doc-pages print-document">
      <ng-content select="[laDocumentBuilderDocument]"></ng-content>
    </div>
  </div>
  <div class="position-sticky bottom-0">
    <ng-content select="[laDocumentBuilderPanelBottom]"></ng-content>
  </div>
</div>
